import { ShiftActivity } from '@bemlo/enums'

import { Color } from '../../constants'
import { BadgeColor } from '../Badge'
import { IconName } from '../Icon'

export const SHIFT_ACTIVITY_COLORS: Record<
  ShiftActivity,
  {
    badge: BadgeColor
    background: Color
    icon: IconName
    iconColor: Color
  }
> = {
  [ShiftActivity.FLEX]: {
    badge: 'yellow',
    background: Color.LIGHT_YELLOW,
    icon: 'LightningBoltIcon',
    iconColor: Color.YELLOW,
  },
  [ShiftActivity.TEAM_MEETING]: {
    badge: 'orange',
    background: Color.ORANGE,
    icon: 'HomeIcon',
    iconColor: Color.ORANGE,
  },
  [ShiftActivity.TRAINING]: {
    badge: 'violet',
    background: Color.VIOLET,
    icon: 'BookOpenIcon',
    iconColor: Color.VIOLET,
  },
  [ShiftActivity.WORK]: {
    badge: 'blue',
    background: Color.LIGHT_BLUE,
    icon: 'SunIcon', // Hmm...
    iconColor: Color.BLUE,
  },
  [ShiftActivity.INTRODUCTION]: {
    badge: 'green',
    background: Color.LIGHT_GREEN,
    icon: 'CubeIcon',
    iconColor: Color.GREEN,
  },
  [ShiftActivity.OTHER]: {
    badge: 'red',
    background: Color.MEDIUM_BLUE,
    icon: 'ClipboardIcon',
    iconColor: Color.DARK_BLUE,
  },
}
